import { render, staticRenderFns } from "./RateReview.vue?vue&type=template&id=8cf1175a&"
import script from "./RateReview.vue?vue&type=script&lang=js&"
export * from "./RateReview.vue?vue&type=script&lang=js&"
import style0 from "./RateReview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RateReview.vue"
export default component.exports